import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import mainColors from '../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: mainColors.white,
      borderRadius: 8,
      borderLeft: `4px solid ${mainColors.sparkBlue}`,
      padding: theme.spacing(4),
      marginBottom: theme.spacing(2),
      color: mainColors.noirBlur,
    },
    title: {
      fontWeight: 700,
      color: mainColors.noirBlur,
      marginBottom: theme.spacing(3),
      fontSize: '20px',
    },
  }),
);

interface Props {
  title: string;
  children: React.ReactNode;
}

const FormSectionCard: React.FC<Props> = ({ title, children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>

      {children}
    </Box>
  );
};

export default FormSectionCard;
